import { useCallback, useState } from 'react';
import { EVENT_TYPE, SERIES_SOURCE } from './useActiveSeriesKeyEmitter';
import useEventEmitter from './useEventEmitter';

// Make sure we are more explict on intent.
// Make specific listeners on the specific label so that all listeners don't refire.
export default function useActiveSeriesKey(eventType) {
  if (eventType === void 0) {
    eventType = EVENT_TYPE;
  }
  const [activeSeriesKey, setActiveSeriesKey] = useState();
  const setActiveSeriesKeyPublic = useCallback(newKey => {
    if (activeSeriesKey !== newKey) setActiveSeriesKey(newKey);
  }, [activeSeriesKey, setActiveSeriesKey]);
  const isSeriesSelected = useCallback(label => {
    if (activeSeriesKey === undefined) return true;
    if (activeSeriesKey === label) return true;
    return false;
  }, [activeSeriesKey]);

  // We will likely move this to the consumer side.
  // If datum is blah trigger this.
  useEventEmitter(eventType, d => setActiveSeriesKeyPublic(d === null || d === void 0 ? void 0 : d.datum), [SERIES_SOURCE]);
  return {
    activeSeriesKey,
    setActiveSeriesKeyPublic,
    isSeriesSelected
  };
}